module.exports = __webpack_public_path__ + "static/media/history_giam.8f1ebf88.png";